import {DataTable} from '../ui/DataTable';
import {Link} from '../ui/ScopedLink';
import {StatusBadge} from '../ui/StatusBadge';
import {formatDateOnly} from '../dates';
import type {Row} from './conveyancing-forms';

export function ConveyancingRegister({rows}:{rows:Row[]}){
 return <DataTable caption={<span className="sr-only">Conveyancing transactions</span>} scrollLabel="Recorded conveyancing transactions" rows={rows} getRowKey={row=>row.id}
  rowHeader={{id:'property',header:'Property / case',render:row=><><Link to={'/contacts/conveyancing/'+row.id}>{row.property||row.case_number}</Link><span className="register-secondary">{row.case_number}</span></>}}
  columns={[
   {id:'type',header:'Transaction',render:row=>row.transaction_type??'Legacy conveyancing case'},
   {id:'stage',header:'Stage',render:row=><StatusBadge text={row.suite_version?row.transaction_stage:'Legacy pack — integration review'}/>},
   {id:'owner',header:'Owner',render:row=>row.owner||'Not assigned'},
   {id:'due',header:'Target date',render:row=>formatDateOnly(row.resolution_due_at,'Not recorded')},
  ]}/>;
}
